import React, {useState} from 'react';
import '../../Notes/DataNoteClient/DataNoteClient.scss';
import PartNoteFooter from '../PartNoteFooter/PartNoteFooter';
//import { idLibraryCreate, idLibraryUpdate } from '../../../AdminView/AdminLibrary/DataLibrary/'
//import {  activateAdminNoteView, addSelectedPartNote } from '../../../adminSlice';
import { divideText } from '../../../../helper/dividerForTextNote';

import Config from '../../../../config/config';
import ImgZoom from '../../ImgZoom/ImgZoom';


const DataNoteClient = (props) => {
   const [openImg, setOpenImg] = useState(false);
   const [noteImgSrc, setNoteSrc] = useState(false); 
    
    const {dispatch} = props;
    

    const serverPath = Config.serverPath;

//OPEN IMG ZOOM
const handleImgZoom = (e) => {
    setOpenImg(true);
    console.log(e.currentTarget.value);
   setNoteSrc(e.currentTarget.value);
}
//CLOSE IMG ZOOM
const handleCloseImgZoom = () => {
    setOpenImg(false);
}


//FIND NOTE
const dataNotes = props.dataNotes;
//const selectedIdNote = props.selectedIdNote;
const selectedNoteId = Number(props.selectedNoteId);
//const selectedNoteId = 41;

//console.log(dataNotes);
const findNote = (selectedId, data ) => {
    const result = data.find(({id}) => id===selectedId);
    return result;
}
const result = findNote(selectedNoteId, dataNotes)
//console.log(result);
//const resultNote = dataNotes.find(({id}) => id===selectedIdNote);
//console.log(resultNote);







//RENDER NOTE PARTS

const renderNoteParts = (data) => {
    //console.log("Start render NotePart")
    //console.log(data);

    return (
        data.map(item => {
           // console.log(item.part);
            const noteName = item.img_path;
            const note_src = noteName? `${serverPath}/api/notes/${selectedNoteId}/${item.img_path}`: null;  
           // console.log(note_src);
            if (note_src) {
                return (
                    <div className='main-container' key={item.part}>

                    
                    <div className='notepart-container' >
                        

                        <div className='img-main-container'>
                        

                        <div className='img-container'>
                            <button className='image-button' value={note_src}  onClick={handleImgZoom} >
                                <img alt="note" src={note_src} />
                            </button>
                                
                        </div>
                        

                            <div className='img-text-container'>
                                
                                <p>{item.img_text}</p>
                            </div>
                        </div>
                        <div className='text-container'>
                        {/*<p className='part'>{props.selectedNoteId}.{item.part}</p>*/}
                        <p className='part'>{item.note_parttitle}</p>
                            {divideText(item.text)}
                        </div>
                        
                           
                        
                        
                    </div>
                        <PartNoteFooter 
                        authData ={props.authData}
                        selectedNoteId={props.selectedNoteId}
                        part={item.part}
                        dataTroubles = {props.dataTroubles}
                        dispatch = {dispatch}
                        />
                    </div>
                )

            } else {
                return (
                    <div className='main-container' key={item.part}>

                        <div className='notepart-container' >
                            
                            
                            <div className='text-container'>
                            <p className='part'>{item.note_parttitle}</p>
                                {divideText(item.text)}
                                
                            </div>
                            
                        </div>
                        <PartNoteFooter
                        authData ={props.authData} 
                        selectedNoteId={props.selectedNoteId}
                        part={item.part}
                        dataTroubles={props.dataTroubles}
                        dispatch = {dispatch}
                        />
                        
                    </div>
                )                
            }
        
          })

    )
  
}


    return (
        <div className='DataNoteClient'>
            
            
            {result ? renderNoteParts(result.content): null}
            {openImg ? <ImgZoom  noteImgSrc={noteImgSrc} onHandleClose = {handleCloseImgZoom}/> : null}
        </div>
    )
}
export default DataNoteClient;